module.exports = __webpack_public_path__ + "img/partiners_1.1104a05a.png";